// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-circle-button {
  color: #1890FF !important;
  margin-left: 0.5rem;
}
.nkl-drawer-header-title {
  padding-top: 5rem;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
